// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2Z3iz","list":"styles_list__3rGtH"};